/**
 * State used in rendering Label
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
